import { render, staticRenderFns } from "./UpdateGeneralInformationStore.vue?vue&type=template&id=d9e4ca76"
import script from "./UpdateGeneralInformationStore.vue?vue&type=script&lang=js"
export * from "./UpdateGeneralInformationStore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports